export default __webpack_public_path__ + "static/media/logoContinental.0393e3ff.svg";